// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';
import {DigitalUserResult} from '../digital-user-search/results/digital-user-result';

export const ProfileDigitalUserSearchResult = DigitalUserResult.extend({
    uuid: t.maybe(t.String),
    isSuccess: t.maybe(t.Boolean),
    errorMessage: t.maybe(t.String)
}, {
    defaultProps: {
        uuid: '',
        isSuccess: null,
        errorMessage: ''
    },
    name: 'ProfileDigitalUserSearchResult',
    strict: false
});
